"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M5 5v10h10V5H5zM4 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H4z"];
//# sourceMappingURL=small-square.js.map